import { render, staticRenderFns } from "./qualityReport.vue?vue&type=template&id=04f0cdb6&scoped=true"
import script from "./qualityReport.vue?vue&type=script&lang=js"
export * from "./qualityReport.vue?vue&type=script&lang=js"
import style0 from "./qualityReport.vue?vue&type=style&index=0&id=04f0cdb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f0cdb6",
  null
  
)

export default component.exports